// extracted by mini-css-extract-plugin
export var container = "_i9-0";
export var content = "_i9-3";
export var customerTitle = "_i9-4";
export var empty = "_i9-5";
export var gray = "_i9-6";
export var header = "_i9-7";
export var info = "_i9-8";
export var loading = "_i9-2";
export var loadingCard = "_i9-9";
export var oneLine = "_i9-a";
export var personName = "_i9-e";
export var pillContainer = "_i9-b";
export var selected = "_i9-1";
export var text = "_i9-c";
export var twoLines = "_i9-d";
export var unread = "_i9-f";
export var unreadIndicator = "_i9-g";